/**
 * Commerce URL helpers — marketplace-neutral.
 * Seed data may still use `#product-LINK` until real affiliate/direct URLs are wired.
 * Optional env: REACT_APP_INSTAGRAM_URL for social chrome.
 */

import { LEGAL } from "./legalConfig";

export const PRODUCT_PLACEHOLDER = "#product-LINK";
/** Site contact — single source of truth via legalConfig. */
export const CONTACT_EMAIL = LEGAL.contactEmail;

/** Instagram profile URL from env when ready; empty = no live link. */
export const INSTAGRAM_URL = (process.env.REACT_APP_INSTAGRAM_URL || "").trim();

/**
 * True only for real http(s) destinations.
 * Placeholders (#product-LINK, bare #, empty) are not live — never invent marketplace URLs.
 */
export function isLiveProductUrl(url) {
  if (!url || typeof url !== "string") return false;
  const trimmed = url.trim();
  if (!trimmed || trimmed === "#" || trimmed === PRODUCT_PLACEHOLDER) return false;
  if (trimmed.startsWith("#")) return false;
  return /^https?:\/\//i.test(trimmed);
}

/** Returns a live URL string or null when the CTA must stay honest/disabled. */
export function resolveProductUrl(url) {
  return isLiveProductUrl(url) ? url.trim() : null;
}
